import { createGlobalStyle } from "styled-components";
import { COLORS } from "./colors";

export default createGlobalStyle`
  :root {
    overscroll-behavior-y: none;
  }
  * {
    padding: 0;
    margin: 0;
    box-sizing: border-box;
  }
  body {
    font-family: 'PlusJakartaSans', sans-serif;
    font-size: 16px;
  }
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-family: 'PlusJakartaSans', sans-serif;
  }
  input,
  button,
  select {
    font-family: inherit;
    font-size: inherit;
    display: block;
    width: 100%;
    height: 44px;
    padding: 0 16px;
    border-radius: 8px;
    border: 1px solid #ccc;
  }
  button {
    font-weight: 400;
  }
  a {
    text-decoration: none;
    color: #007aff;
  }
  ul {
    list-style: none;
  }
  button,
  a,
  label,
  input {
    -webkit-tap-highlight-color: transparent;
  } 
  
  .field-array-wrapper {
    padding: 16px;
    background: $white;
    margin-bottom: 24px;
    border-radius: 16px;
    border: 1px solid $gray-eighty;
    .field-array-label {
      margin-bottom: 16px;
    }
  }
  
  .field-array-item {
    display: flex;
    // justify-content: space-between;
    .form-group {
      width: 150px;
      margin-right: 16px;
    }
  }
  
  .date-picker-wrapper{
    .react-date-picker__wrapper {
      border: none;
    }
    .react-date-picker__clear-button {
      background: transparent;
      color: #333;
    }
    .react-calendar {
      border-radius: 16px;
      border: 1px solid #ccc;
      font-family: inherit;
      button {
        color: #333;
        padding: 4px;
        height: 40px;
        &.react-calendar__tile--active {
          color: #fff;
        }
      }
    }
  }

  .modal {
    margin: 16px;
    @media(max-width: 480px) {
      margin: 8px;
    }
  }

  .overlay {
    position: fixed;
    background-color: rgba(0, 0, 0, 0.65);
    display: flex;
    justify-content: center;
    align-items: center;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 99;
  }

  .ReactModal__Overlay {
    opacity: 0;
    transition: opacity 300ms ease-in-out;
  }

  .ReactModal__Overlay--after-open{
    opacity: 1;
  }

  .ReactModal__Overlay--before-close{
    opacity: 0;
  }
  .ReactModal__Overlay .modal {
    opacity: 0;
    transform: translateY(-100px);
    transition: all 300ms ease-in-out;
  }
  
  .ReactModal__Overlay--after-open .modal {
    opacity: 1;
    transform: translateY(0px);
  }
  
  .ReactModal__Overlay--before-close .modal {
    opacity: 0;
    transform: translateY(-100px);
  }

  .react-select__input {
    height: 36px;
  }
  .react-select__value-container--has-value {
    .react-select__input {
      height: 20px;
    }
  }
  .react-select__value-container {
    padding: 0 16px !important;
  }
  .react-select__control {
    min-width: 100px;
    height: auto;
    border-radius: 8px !important;
    text-align: left;
    border-color: #007aff !important;
    &.react-select__control--is-focused {
      min-height: 42px;
      border-radius: 16px;
      border-width: 2px;
      box-shadow: none;
      border-color: #007aff !important;
    }
  }
  .react-select__menu {
    min-width: 280px;
    left: 0;
  }
  .react-select-right {
    .react-select__menu {
      left: initial;
      right: 0;
    }
  }
  .react-select__multi-value {
    background-color: ${COLORS.background.primaryLight};
    color: ${COLORS.text.primary};
    border-radius: 8px !important;
    margin: 0;
    .react-select__multi-value__label {
      color: ${COLORS.text.primary};
    }
    .react-select__multi-value__remove {
      color: ${COLORS.text.primary};
      border-radius: 0 8px 8px 0 !important;
    }
  }
`;
